// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle__2XKgJ","active":"SectionTitle_active__3b7lj"};